import { withSuspense } from '@app/shared/HOCs/withSuspense';
import { lazyNamed } from '@app/shared/utils/lazyNamed';

export const ServicesSortingLazy = withSuspense(
  lazyNamed(() => import('../ServicesSorting/ServicesSorting.main'))
);
